// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2dfp5","label":"LabeledBox_label__k6bbR"};